import React from 'react';

import { Typography, withTypography } from 'ucl/components/text/Typography';

import { IBaseProps } from '@rbi-ctg/frontend';
import { Box } from 'components/ui';
import { tRich } from 'state/intl/translations';

import { AllergenGroup } from './types';
import { allergenIncludesToIntlId } from './utils';

const AllergensText = withTypography({ variant: 'copyTwo', bold: true, fontSize: 'sm' });

export interface IAllergensProps extends IBaseProps {
  allergenGroups: AllergenGroup[];
}

export const Allergens: React.FC<React.PropsWithChildren<IAllergensProps>> = ({
  allergenGroups,
}) => {
  if (!allergenGroups.length) {
    return null;
  }

  return (
    <Box testID="allergens">
      {allergenGroups.map(group => {
        const id = allergenIncludesToIntlId(group.allergenIncludes);
        if (!id) {
          return null;
        }
        const allNames = group.allergenNames.join(', ');
        return (
          <AllergensText key={id}>
            {tRich(id, {
              allergens: (
                <Typography style={{ fontWeight: 'normal', textTransform: 'capitalize' }}>
                  {allNames}
                </Typography>
              ),
            })}
          </AllergensText>
        );
      })}
    </Box>
  );
};
